import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'

import colors from 'airship/design-system/theme/foundations/colors'

import sizes from '../foundations/sizes'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const helpers = createMultiStyleConfigHelpers([
  'options',
  'heading',
  'label',
  'stack',
  'description',
  'content',
])

const OptionTheme = helpers.defineMultiStyleConfig({
  baseStyle: {
    options: {
      padding: spacing.xs,
      borderColor: colors.border.primary,
      minW: sizes['4xl'],
      maxW: '1280px',
    },
    heading: {
      width: spacing.xs,
    },
    label: {
      ...typography.textStyles.subheading.medium,
      textColor: colors.text.primary,
    },
    stack: {
      height: spacing['6xs'],
    },
    description: {
      ...typography.textStyles.body.medium,
      textColor: colors.text.tertiary,
    },
    content: {
      maxWidth: sizes['7xl'],
      paddingBottom: spacing['5xs'],
    },
  },
})

export default OptionTheme
